import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ChatHeader from '@rsos/components/capstone/Chat/ChatHeader';
import TalkJSChatbox from '../../../TalkJSChatbox/TalkJSChatbox';
import { CHAT_SOURCE_ASC } from '../CallChats';
import {
  ChatBoxContainer,
  Container,
  CHAT_HEADER_HEIGHT,
  ChatWrapper,
} from './ASCChatBox.styles';

const AgencyShareChatBox = ({
  bothChatsEnabled,
  isAgencyShareChatChatBoxVisible,
  onCollapseChat,
}) => {
  const [callChatParticipants, setCallChatParticipants] = useState([]);

  const currentPSAP = useSelector(state => state.psaps.currentPSAP);
  const callerID = useSelector(state => state.emergencyCalls.selectedCallerID);
  const currentCall = useSelector(
    state => state.emergencyCalls.callQueue[callerID],
  );

  const handleActionButtonClick = () => {
    onCollapseChat(CHAT_SOURCE_ASC);
  };

  // For 911 calls, backend is sending back the full list of chat participants,
  // frontend has to filter out the current PSAP from the list due to design.
  // The list of chat participants can change as agencies join/leave the conversation.
  useEffect(() => {
    if (currentCall?.agencyShareChat?.chatParticipants) {
      const filteredChatParticipants = currentCall.agencyShareChat.chatParticipants.filter(
        participant => participant.account_id !== currentPSAP.account_id,
      );
      setCallChatParticipants(filteredChatParticipants);
    }
  }, [currentCall, currentPSAP.account_id]);

  const chatHeight = useMemo(() => {
    if (isAgencyShareChatChatBoxVisible) {
      if (bothChatsEnabled) {
        return '50%';
      }
      return '100%';
    }
    return CHAT_HEADER_HEIGHT;
  }, [isAgencyShareChatChatBoxVisible, bothChatsEnabled]);

  return (
    <Container
      height={chatHeight}
      maxHeight={isAgencyShareChatChatBoxVisible ? '100%' : CHAT_HEADER_HEIGHT}
      pt={bothChatsEnabled ? '8px' : 0} // space between chats
    >
      <ChatWrapper>
        <ChatHeader
          callChatParticipants={callChatParticipants}
          isChatBoxVisible={isAgencyShareChatChatBoxVisible}
          isUnread={currentCall?.agencyShareChat?.isUnread}
          onActionButtonClick={handleActionButtonClick}
        />
        <ChatBoxContainer data-name="ChatBoxContainer">
          <TalkJSChatbox />
        </ChatBoxContainer>
      </ChatWrapper>
    </Container>
  );
};

export default AgencyShareChatBox;
